import React from "react";
import {
  Create,
  AutocompleteInput,
  SaveButton,
  List,
  FunctionField,
  Datagrid,
  TextField,
  Pagination,
  ReferenceField,
  Button,
  Link,
  Toolbar,
  Edit,
  SimpleForm,
  EditButton,
  ReferenceInput,
  TextInput,
  DeleteButton,
  BooleanInput,
} from "react-admin";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { TextBooleanField } from "../components/TextBooleanField";
// import { CustomBaseFilter } from "../components/selectboxfilter/customBaseFilter";

const ListPagination = props => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const GuideTitle = object => (
  <span>
    {" Edit Guide entry "} {object.record.name}
  </span>
);

const GuideCreateTitle = record => <span>Create Guide entry</span>;

// const GuidesListFilter = props => (
//   <Filter {...props}>
//     <CustomBaseFilter label="Base Location" source="location_id" alwaysOn />
//   </Filter>
// );

const validateForm = values => {
  const errors = {};
  if (!values.name) {
    errors.name = ["Name is required"];
  }
  if (!values.user_id) {
    errors.user_id = ["User is required"];
  }
  return errors;
};

export const GuidesList = props => (
  <List
    {...props}
    title="Guides"
    resource="guides"
    pagination={<ListPagination />}
    // filters={<GuidesListFilter />}
    bulkActionButtons={false}
  >
    <Datagrid>
      <TextField label="Guide ID" source="id" />
      <TextField label="Name" source="name" />
      <ReferenceField
        label="User"
        source="user_id"
        reference="users"
        linkType={false}
        allowEmpty={true}
      >
        <FunctionField render={user => `${user.email}`} />
      </ReferenceField>
      <TextBooleanField label="Active" source="status" />
      />
      <EditButton />
    </Datagrid>
  </List>
);

const GuidesToolbar = props => (
  <Toolbar {...props}>
    <SaveButton redirect={`/guides`} />
    <Button
      component={Link}
      to={{
        pathname: `/guides`
      }}
      label="Back to Guides"
    >
      <ArrowBackIcon />
    </Button>
    <DeleteButton record={props.record} resource={props.resource} />
  </Toolbar>
);

const GuidesToolbarC = props => (
  <Toolbar {...props}>
    <SaveButton redirect={`/guides`} />
    <Button
      component={Link}
      to={{
        pathname: `/guides`
      }}
      label="Back to Guides"
    >
      <ArrowBackIcon />
    </Button>
  </Toolbar>
);

export const GuidesEdit = props => (
  <Edit title={<GuideTitle />} {...props}>
    <SimpleForm
      toolbar={<GuidesToolbar props={{ ...props }} />}
      validate={validateForm}
    >
      <TextInput label="Name" source="name" />
      <ReferenceInput
        label="User"
        source="user_id"
        reference="users"
        filter={{ isGuide: "true" }}
        perPage={100}
        sort={{ field: "email", order: "ASC" }}
        allowEmpty={true}
      >
        <AutocompleteInput optionText={user => `${user.email}`} />
      </ReferenceInput>
      <ReferenceInput
        label="Location"
        source="location_id"
        reference="locations"
        filter={{ only_bases: "true" }}
        sort={{ field: "location_name", order: "ASC" }}
      >
        <AutocompleteInput
          optionText={location => `${location.location_name}`}
        />
      </ReferenceInput>
      <BooleanInput label="Active" source="status" />
    </SimpleForm>
  </Edit>
);

export const GuidesCreate = props => (
  <Create title={<GuideCreateTitle />} {...props}>
    <SimpleForm
      validate={validateForm}
      toolbar={<GuidesToolbarC props={{ ...props }} />}
    >
      <TextInput label="Name" source="name" />
      <ReferenceInput
        label="User"
        source="user_id"
        reference="users"
        filter={{ guides: "true" }}
        sort={{ field: "username", order: "ASC" }}
      >
        <AutocompleteInput optionText={user => `${user.email}`} />
      </ReferenceInput>
      <ReferenceInput
        label="Location"
        source="location_id"
        reference="locations"
        filter={{ only_bases: "true" }}
        sort={{ field: "location_name", order: "ASC" }}
      >
        <AutocompleteInput
          optionText={location => `${location.location_name}`}
        />
      </ReferenceInput>
      <BooleanInput label="Active" source="status" />
    </SimpleForm>
  </Create>
);



// WEBPACK FOOTER //
// ./src/resources/guides.js